import { createClient } from 'contentful';

const contentClient = createClient({
  space: '1fvyf6izgrso',
  accessToken: '971609194e459fac7c3b8dd5f6cdb9bdcaadf0450e4632137504c1fdc0c8d069',
});

const ContentfulService = {
  contentClient,
  fetchContent(params = {
    content_type: 'page',
    include: 10,
    order: '-sys.createdAt',
  }) {
    return this.contentClient.getEntries(params).then(response => response.items);
  },
};

export default ContentfulService;
